import React, { useEffect } from 'react'
import { Form, Modal, Input, Switch } from 'antd'
import RowLayout from '../../commons/RowLayout/RowLayout'

const SubmenuModal = ({ T, isOpen, onCancel, onOk, info = {} }) => {
    const [form] = Form.useForm()

    useEffect(() => {
        if (isOpen) {
            form.setFieldsValue({
                title: info.title,
                url: info.url,
                isNewTab: info.is_new_tab
            })
        }
    }, [isOpen])

    function onFinish(values) {
        let data = {
            title: values.title,
            url: values.url,
            is_new_tab: values.isNewTab
        }
        onOk(data)
    }

    return (
        <Modal
            form={form}
            width={640}
            title={T('MENU')}
            visible={isOpen}
            centered
            okText={T('SAVE')}
            cancelText={T('CANCEL')}
            onOk={() => {
                form.validateFields()
                    .then(values => {
                        form.resetFields()
                        onFinish(values)
                    })
                    .catch(err => {
                        console.log('Validate Failed:', err)
                    })
            }}
            onCancel={() => onCancel()}>
            <Form form={form}>
                <RowLayout title={T('TEXT')} contentSpan={16}>
                    <Form.Item name="title">
                        <Input placeholder={T('TEXT')} />
                    </Form.Item>
                </RowLayout>
                <RowLayout title={T('URL')} contentSpan={16}>
                    <Form.Item name="url">
                        <Input placeholder={'e.g. https://www.indytheme.com'} />
                    </Form.Item>
                </RowLayout>
                <RowLayout title={T('OPEN_NEW_TAB')} contentSpan={16}>
                    <Form.Item name="isNewTab" valuePropName="checked">
                        <Switch />
                    </Form.Item>
                </RowLayout>
            </Form>
        </Modal>
    )
}

export default SubmenuModal
